const REPORT_PROD_BASE = "https://hzshixiang.site/report/prod";

/**
 * 鉴别作业行 → 小程序 jbReport 报告模板页二维码链接。
 *
 * 注意：二维码 id 使用业务订单主键 orderId（xw_order / secondhand_order），
 * 不是鉴别作业表主键 id。
 *
 * 小程序 orderType 与鉴别作业 orderType 含义不同：
 * - 作业 orderType 1/2（寄售、鉴别）→ mini orderType=normal
 * - 作业 orderType 3/4（闲置、安心购）→ mini orderType=secondhand
 */
export function buildInspectionJobReportQrUrl(row) {
  if (!row || row.orderId == null) return "";
  const orderId = row.orderId;
  const jobOrderType = Number(row.orderType);
  let miniOrderType = "";
  if (jobOrderType === 1 || jobOrderType === 2) {
    miniOrderType = "normal";
  } else if (jobOrderType === 3 || jobOrderType === 4) {
    miniOrderType = "secondhand";
  }
  const base = `${REPORT_PROD_BASE}?id=${orderId}`;
  return miniOrderType ? `${base}&orderType=${miniOrderType}` : base;
}

/** 标签侧六位数字：取订单号末六位（与鉴别订单列表「鉴别报告打印」一致） */
export function inspectionJobReportLabelSuffix(row) {
  const orderNoStr = row && row.orderNo != null ? String(row.orderNo) : "";
  return orderNoStr.slice(-6);
}

/** 是否已出具鉴别结论，可打印报告二维码 */
export function canPrintInspectionJobReport(row) {
  if (!row || row.orderId == null) return false;
  const result = Number(row.result);
  return result === 1 || result === 2;
}



// WEBPACK FOOTER //
// ./src/util/inspectionReportQr.js